module.exports = __webpack_public_path__ + "static/media/44.f9b8c6cb.jpg";